// NoteBookmarkList.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function NoteBookmarkList({caller}){

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const noteBookmarkList = useSelector((state) => state.noteBookmarkList.noteBookmarkList);
    const bookList = useSelector((state) => state.home.bookList);
    const noteBookmarkListBookChapterVerse = useSelector((state) => state.noteBookmarkList.noteBookmarkListBookChapterVerse);
    const pageNumberNote = useSelector((state) => state.noteBookmarkList.pageNumberNote);
    const pageNumberNoteSearch = useSelector((state) => state.noteBookmarkList.pageNumberNoteSearch);
    //const noteSearchString = useSelector((state) => state.noteSearch.noteSearchString);
    const confirmedNoteSearchString = useSelector((state) => state.noteSearch.confirmedNoteSearchString);
    const loading4Home = useSelector((state) => state.home.loading4Home);
    const userListItem = useSelector((state) => state.home.userListItem);
    const viewArea = useSelector((state) => state.home.viewArea);    

    // const handleDialogClose4 = () => {
    //     dispatch(setOpen4(false));
    // }

    useEffect(() => {
        if (caller === 'Note' && noteBookmarkListBookChapterVerse.book > 0 && noteBookmarkListBookChapterVerse.chapter > 0 && noteBookmarkListBookChapterVerse.verse > 0) {
            dispatch(setNoteBookmarkList({resultTotal: -1, noteBookmarkList: []}));
            getNoteBookmarkList('NoteBookmarkList');
        }
    }, [pageNumberNote, noteBookmarkListBookChapterVerse]);

    useEffect(() => {   
        console.log('pageNumberNoteSearch changed:', pageNumberNoteSearch);     
        if (caller === 'NoteSearch' && pageNumberNoteSearch >= 0) {
            dispatch(setNoteBookmarkList({resultTotal: -1, noteBookmarkList: []}));
            getNoteBookmarkList3(confirmedNoteSearchString, 'NoteBookmarkList');
        }
    }, [confirmedNoteSearchString, pageNumberNoteSearch]);

    useEffect(() => {   
        dispatch(setCaller4NoteBookmarkList(caller));
    }, []);

    if (noteBookmarkList.resultTotal > 0) {

        return (

            <div>

                {/* caller: {caller} */}
                {/* {viewArea} */}
                {caller === 'Note' &&
                <Grid
                    size={12} 
                    sx={{ 
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: 3,
                    }}
                >
                    {viewArea === 'Note' &&
                    <Alert icon={false} variant="filled" sx={{ color: 'white', backgroundColor: 'primary.main' }}>
                        {getBookChapterVerseChineseName(bookList, noteBookmarkListBookChapterVerse.book, noteBookmarkListBookChapterVerse.chapter, noteBookmarkListBookChapterVerse.verse, false, false)}
                    </Alert>
                    }
                </Grid>
                }
                <Grid
                    sx={{ 
                        marginBottom: 10,
                    }}                
                >
                    <TableContainer>
                        <Table>
                            <TableBody>
                                {noteBookmarkList.noteBookmarkList.map((noteBookmarkListItem, index) => (
                                <TableRow 
                                    key={index}
                                >
                                    <TableCell sx={{ verticalAlign: 'top', padding: 2 }} >
                                        <NoteBookmarkListItem noteBookmarkListItem={noteBookmarkListItem}/>
                                    </TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                        </Table>    
                    </TableContainer>        
                </Grid>

                <Grid>      
                    {userListItem && 
                    <span><VerseLabelArrows4Result caller={caller}/></span>
                    }
                </Grid>

                {/* {loading4Home && <ClipLoader1 />} */}

            </div>
        )
    } else {
        return (

            <div>

                <Grid
                    size={12} 
                    sx={{ 
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: 3,
                    }}
                >
                    {viewArea === 'Note' && noteBookmarkListBookChapterVerse.book > 0 && noteBookmarkListBookChapterVerse.chapter > 0 && noteBookmarkListBookChapterVerse.verse > 0 &&
                    <Alert icon={false} variant="filled" sx={{ color: 'white', backgroundColor: 'primary.main' }}>
                        {getBookChapterVerseChineseName(bookList, noteBookmarkListBookChapterVerse.book, noteBookmarkListBookChapterVerse.chapter, noteBookmarkListBookChapterVerse.verse, false, false)}
                    </Alert>
                    }
                </Grid>

                <Grid>      
                    {userListItem && 
                    <span><VerseLabelArrows4Result caller={caller}/></span>
                    }
                </Grid>

                {/* {loading4Home && <ClipLoader1 />} */}

            </div>

        )        
    }
}